import React, { useState, useEffect } from 'react';
import { TextFieldProps, FieldError, FormController } from '../models';
import FieldWrapper from '../FieldWrapper';
import { NumericCodeControl, TextControl } from '../controls';

const TextField: React.FC<TextFieldProps> = (props) => {
  const [blurredOnce, setBlurredOnce] = useState(false);
  const [error, setError] = useState<FieldError>(false);
  const validate = (value: string): boolean => {
    const error = props.getFieldError ? props.getFieldError(value) : false;
    setError(error);
    return !error;
  };
  const allProps = {
    ...props,
    type: props.type || 'text',
    hasError: Boolean(error),
    onBlur(event: React.FocusEvent<HTMLInputElement>) {
      props.onBlur && props.onBlur(event);
      validate(event.target.value);
      setBlurredOnce(true);
    },
    onChange(event: React.ChangeEvent<HTMLInputElement>) {
      props.onChange && props.onChange(event);
      if (blurredOnce) {
        validate(event.target.value);
      }
    },
  };

  useEffect(() => {
    if (props.formController) {
      props.formController.validationHandlers[props.name] = () => validate(props.value as string);
      return () => {
        delete (props.formController as FormController).validationHandlers[props.name];
      };
    }
    return;
  });

  return (
    <FieldWrapper {...props} showInputWidget={props.controlType !== 'code'} error={error}>
      {props.controlType === 'code' ? (
        <NumericCodeControl {...allProps} maxLength={allProps.maxLength || 0} />
      ) : (
        <TextControl {...allProps} />
      )}
    </FieldWrapper>
  );
};

export default TextField;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/forms/fields/TextField.tsx